import {
  GET_APPS,
  GET_APPS_SUCCESS,
  GET_APPS_ERROR,
  DELETE_APP,
  DELETE_APP_SUCCESS,
  DELETE_APP_ERROR
} from "./actionTypes"

const initialState = {
  apps: null,
  error: "",
  success: "",
  loader : false
}

const thirdPartyAppReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPS:
      state = {
        ...state,
        apps: null,
        error: "",
        success:"",
        loader:true
      }
      break
    case GET_APPS_SUCCESS:
      state = {
        ...state,
        apps: action.payload,
        loader:false
      }
      break
    case GET_APPS_ERROR:
      state = {
        ...state,
        error: action.payload,
        loader: false 
      }
      break
    case DELETE_APP:
      state = {
        ...state,
        error: "",
        success:"",
        loader:true
      }
      break
    case DELETE_APP_SUCCESS:
      state = {
        ...state,
        success: action.payload,
        loader:false
      }
      break
    case DELETE_APP_ERROR:
      state = {
        ...state,
        error: action.payload,
        loader:false
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}
export default thirdPartyAppReducer
